import React, { useRef } from "react";
import { ScrollWrapper, GalleryContainer, NavButton, Thumbnail } from "./style";

interface ICarouseProps {
  media_id: string;
  media_path: string;
  link: string;
}

export const Carousel: React.FC<{
  medias: ICarouseProps[];
}> = ({ medias }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 100;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const render_image = () => {
    return medias.map((image) => {
      return (
        <a
          href={image.link}
          target="_blank"
          rel="noopener noreferrer"
          key={`carousel_${image.media_id}`}
        >
          <Thumbnail src={image.media_path} />
        </a>
      );
    });
  };

  return (
    <>
      <GalleryContainer>
        <NavButton direction="left" onClick={() => scroll("left")}>
          ◀
        </NavButton>

        <ScrollWrapper ref={scrollRef}>{render_image()}</ScrollWrapper>
        <NavButton direction="right" onClick={() => scroll("right")}>
          ▶
        </NavButton>
      </GalleryContainer>
    </>
  );
};
